import moment from 'moment-timezone';

const date = (value) => {
  try {
    return moment(value).format('YYYY-MM-DD HH:mm:ss');
  } catch (e) {
    console.error(e);
    return value;
  }
};

const formatDate = (value, format= 'dateTime') => {
  let dateFormat = '';
  switch (format) {
    case 'time':
      dateFormat = 'HH:mm';
      break;
    case 'date':
      dateFormat = 'YYYY-MM-DD';
      break;
    case 'dateTime':
      dateFormat = 'YYYY-MM-DD HH:mm';
      break;
    default:
      dateFormat = 'YYYY-MM-DD HH:mm:ss';
  }
  try {
    // TODO: TZ testing
    // if (!moment.tz(value, 'America/New_York').local().isValid()) throw new Error('invalidDate');
    // return moment.tz(value, 'America/New_York').local().format(dateFormat);
    // return moment(value).format(dateFormat);
    if (!moment(value).isValid()) throw new Error('invalidDate');
    return moment.utc(value).local().format(dateFormat);
  } catch (e) {
    console.error(`${e} ${value}`);
    return value;
  }
}

const uniDate = value => {
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  return moment(value).isValid() ? moment.utc(value).local().format(dateFormat) : moment().format(dateFormat);
}

export { date };
export { uniDate };
export { formatDate };
